define('lib/rest',['jquery'], function($) {
  var $rest = {},
    keyRegex = /^(\S+?)(?=\(\S+\)|$)(?:\((\S+)\))?$/;

  function __processUrlParams(url, params)  {
    // Build the request path
      // This replaces elements in the url according to the format
      // {data param:default value}
      url = url.replace(/\{\{|\}\}|\{([^}: ]+?)(?::([^}]*?))?\}/g, function(match, name, def) {
          if (match === '{{') {
              return '{';
          } else if (match === '}}') {
              return '}';
          } else {
            var raw = false;
            if(name.indexOf('!') >= 0) {
          var tokens = name.split('!'),
            mod = tokens[0];
              raw = mod === 'raw';
              name = tokens[1];
            }

            if(params[name] !== void 0) {
                var v = params[name];
                delete params[name];
                return raw ? v : encodeURIComponent(v);
            } else {
                return def === void 0 ? '' : def;
            }
      }
      });

      return url;
  };

  function __generateApi(target, key, config) {
    var match = keyRegex.exec(key),
      path = match[1],
      argName = match.length == 3 ? match[2] : null;

    var api = function() {
      var result = Object.create(api.prototype);
      if(argName) {
        var context = {};
        context[argName] = arguments.length >= 1 ? arguments[0] : '';
        result.context = $.extend({}, this.context, context);
      }

      return result;
    };

    // TODO: Add deep api support
    var proto = {
      _rest: target,
      context: null,
      url: config.url
    };

    $.each(config.calls, function(name, config) {
      proto[name] = __generateRequest(name, config, proto);
    });

    api.prototype = proto;
    target[path] = api;
    return api;
  }

  function __generateRequest(name, config, api) {
    var request = function() {
      var url = api.url + (config.url === void 0 ? name : config.url),
        params = $.extend({}, config.defaults, this.context);

      url = url.replace(/\/+/g, '/'); // remove any double //

      if(api._rest.spec.host) {
        url = api._rest.spec.host + url;
      }

      if(arguments.length) {
        $.extend(params, arguments[0]);
      }
      var requestConfig = Object.assign({method: 'GET'}, config, {url: url});
      return api._rest.makeRequest(requestConfig, params);
    }

    return request;
  }

  function RestAPI(spec, options) {
    this.spec = spec;
    this.defaults = $.extend({}, options);

    var self = this;
    $.each(spec.apis, function(key, reqConfig) {
      __generateApi(self, key, reqConfig);
    });
  }

  RestAPI.prototype.makeRequest = function(config, params) {
    params = $.extend({}, this.defaults.params, params);

    var url = __processUrlParams(config.url, params);

    if(config.stringify){
      params = JSON.stringify(params);
    }

    if(config.generator === true) {
      if(config.immediate === true) {
        return url;
      } else {
        return Promise.resolve({url: url});
      }
    } else {
      var reqConfig = {
        method: config.method,
        url: url,
        data: params
      };

      $.each(['accepts', 'dataType', 'contentType', 'processData'], function(idx, k) {
        if(config.hasOwnProperty(k)) {
          reqConfig[k] = config[k];
        }
      });

      return $.ajax(reqConfig);
    }
  };

  return RestAPI;
});

